export class PermisoViajeResponse {
    permisos:PermisoViaje[];
    participantes:any;
    
}

export class PermisoViaje{
    numeroControl:string = '';
    fechaIngreso:string = '';
    encargado:string = '';
    lugarFormulario:string = '';
    observacion:string = '';
    tipoPermiso:string = '';
    
}